import React, { useState,useEffect } from 'react';
import {Nav, Navbar, NavDropdown} from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import {trackEvent} from "../../services/analytics";

const LandingPageNav = props => {
    const { t, i18n } = useTranslation();
    const [ lang, setLang ] = useState('en');
    const [ loading, setLoading ] = useState(true);

    useEffect(()=> {
        setLoading(false);
    },[]);



    const onClickSignIn = (name) => {
        trackEvent('Click',{
            action: "track",
            category: "Buttons",
            label: name,
            event: "Click"
        })
    };

    const onClickSignUp = (name) => {
        trackEvent('Click',{
            action: "track",
            category: "Buttons",
            label: name,
            event: "Click"
        })
    };

    return (
        <Navbar expand="lg"  className="landing-nav justify-content-between pt-2" >
            <a className="navbar-brand" id="header-logo" href="/">
                <img
                    className="h-8 w-8 rounded-full" 
                    style={{height:40}}
                    src={"/images/logos/biteship.png"} 
                    alt=""
                />
            </a>
            <Navbar.Toggle />
            <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
                <Nav>
                    <NavDropdown className="mx-5 text-center" title={
                        <span className="text-primary my-auto ">{t('nav.product')}</span>
                    } id="basic-nav-dropdown">
                        <NavDropdown.Item className="mt-2" href="/shipping">
                            <h6>Shipping</h6>
                            <p className="text-muted">Layanan pengiriman berbagai kurir</p>
                        </NavDropdown.Item>
                        <NavDropdown.Item href="/plugin">
                            <h6>Plugins</h6>
                            <p className="text-muted">Integrasi layanan ke E-Commerce</p>
                        </NavDropdown.Item>
                        <NavDropdown.Item href="/fulfillment">
                            <h6>Fulfillment</h6>
                            <p className="text-muted">{t('nav.fulfillmentServiceDesc')}</p>
                        </NavDropdown.Item>
 
                    </NavDropdown>

                    <Nav.Link
                        href="/pricing"
                        className="mx-5 text-primary btn header-nav-link"
                    >
                        {t('nav.pricing')}
                    </Nav.Link>

                    <NavDropdown className="mx-5 text-center" title={
                        <span className="text-primary my-auto">DEVELOPER</span>
                    } id="basic-nav-dropdown">
                        <NavDropdown.Item href="/docs/api">
                            <h6>{t('nav.apiDocs')}</h6>
                            <p className="text-muted">{t('nav.apiDocsDesc1')}<br/> {t('nav.apiDocsDesc2')}</p>
                        </NavDropdown.Item>
                    </NavDropdown>

                    <Nav.Link
                        href="https://dashboard.biteship.com/signin"
                        className="mx-5 text-primary btn header-nav-link"
                        onClick={() => onClickSignIn('Sign In Top Header')}
                    >
                        {t('auth.signIn')}
                    </Nav.Link>
                    <Nav.Link
                        href="https://dashboard.biteship.com/signup"
                        className="mx-5 text-primary btn btn-primary header-nav-link text-white"
                        onClick={() => onClickSignUp('Sign Up Top Header')}
                    >
                        {t('auth.signUp')}
                    </Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    )
};

export default LandingPageNav;
